<template>
    <div>
        <transition name="loading-page" mode="in-out">
            <div class="loading-page" v-if="!showPageContent">
                <div class="loading-page-box">
                    <base-spinner />
                    <!-- <div class="loading-page-title">Carregando...</div> -->
                </div>
            </div>
        </transition>

        <transition name="product-page" mode="in-out">
            <div class="product-page" id="productPage" v-if="showPageContent">
                <div
                    id="propertHeader"
                    class="product-header"
                    :style="{ backgroundImage: `url(${mainImageComputed})` }"
                >
                    <div class="product-header-background">
                        <div class="product-header-mobile">
                            <div class="grid-container">
                                <div class="grid">
                                    <div class="column-2">
                                        <!-- <button-go-back /> -->
										<div class="logo">
											<!-- <a href="#"> -->
												<img :src="require('@/Assets/Images/logos/facilita-marketplace-icon-branco.svg')" alt="App Facilita">
											<!-- </a> -->
										</div>
                                    </div>

                                    <div class="column-2">
                                        <button-mobile-menu />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="product-header-top">
                            <div class="grid-container">
                                <div class="grid">
                                    <div class="column-2 product-header-breadcrumb">
                                        <base-breadcrumbs
                                            v-if="breadcrumbs"
                                            :breadcrumbs="breadcrumbs"
                                            :iconWhite="true"
                                            hideHome
                                            noLink
                                        />
                                    </div>
                                    <div class="column-2 product-header-nav">
										<the-navigation _class="no-list-style"/>
                                        <!-- <button
                                            class="button -rounded -large -alt"
                                            :class="{ 'sr-only': showPhone }"
                                            @click="showUserPhone()"
                                        >
                                            <h4 class="icon fab fa-whatsapp" aria-hidden="true"></h4>
                                            Entrar em contato
                                        </button> -->
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="product-header-middle">
                            <div class="grid-container">
                                <div class="product-title">
                                    <strong class="address" v-if="product.infos.title">
                                        <template>{{ product.infos.title }} {{ product.uf ? ', ' + product.uf : '' }}</template>
                                    </strong>

                                    <h1 class="title" v-if="product.name">{{ product.name }}</h1>

									<h2 class="desc" v-if="bedroomComputed || areaComputed">
										{{ categoryComputed }}
                                        <span class="alt" v-if="bedroomComputed"
                                            >{{ listFormat(bedroomComputed) }} quartos,
                                        </span>

                                        <template v-if="areaComputed">
                                            <span> {{ areaComputed }}</span> de área privativa.
                                        </template>
                                    </h2>

									<p class="badges" v-if="typeComputed || statusComputed">
										<template  v-if="typeComputed" >
                                        <span v-for="type in typeComputed" :key="type" class="badge -rounded -contrast">
                                            {{ type }}
                                        </span>
										</template>
                                        <span class="badge -rounded -contrast" v-if="statusComputed">
                                            {{ statusComputed }}
                                        </span>
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="product-header-bottom">
                            <div class="grid-container">
                                <div class="grid">
                                    <div class="column product-header-gallery">
                                        <p class="copyright" v-if="incorporationRecordField">
                                            Registro de Incorporações: <span>{{ incorporationRecordField }}</span>
                                        </p>
                                        <div class="main-gallery">
                                            <div class="embed ratio16by9">
                                                <div
                                                    class="embed-item"
                                                    :style="{ backgroundImage: 'url(' + mainImageComputed + ')', backgroundSize: 'cover' }"
                                                ></div>
                                            </div>
                                            <button
                                                v-if="mainSlideComputed"
                                                class="button -medium -rounded -border-light"
                                                @click="$root.$emit('showModal', `${idComputed}`)"
                                            >
                                                <i class="fal fa-search-plus"></i> Abrir Galeria
                                            </button>

                                            <base-modal v-if="mainSlideComputed" :id="idComputed" :lightbox="true">
                                                <base-slider class="product-slider" :arrows="true" :dots="true">
                                                    <base-slide>
                                                        <figure>
                                                            <img :src="mainImageComputed" />
                                                        </figure>
                                                    </base-slide>
													<base-slide v-for="slide in mainSlideComputed" :key="slide.file_id">
                                                        <figure>
                                                            <img :src="optimizedImageUrl(slide)" :alt="slide.file.name" />
                                                        </figure>
                                                    </base-slide>
                                                </base-slider>
                                            </base-modal>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- /.global-header -->

                <div class="product-content grid-container">
                    <div class="product-content-wrap">
                        <ul
                            class="product-options"
                            v-if="garageComputed || restroomComputed || bedroomComputed || suiteComputed"
                        >
                            <li class="option" v-if="bedroomComputed || suiteComputed">
                                <span class="option-value">
									<i class="fal fa-bed option-icon"></i>
								</span>
                                <span class="option-text">
									{{ fromToListFormat(bedroomComputed) }}
                                    Dormitórios
                                    <span class="option-text-small">{{ fromToListFormat(suiteComputed) }} Suítes</span>
                                </span>

                            </li>
                            <li class="option" v-if="garageComputed">
                                <span class="option-value">
                                <i class="fal fa-car-side option-icon"></i>
									</span>
                                <span class="option-text">
									{{ fromToListFormat(garageComputed) }}
									Garagens
								</span>
                            </li>
                            <li class="option" v-if="restroomComputed">
                                <span class="option-value">
                                <i class="fal fa-bath option-icon"></i>
									</span>
                                <span class="option-text">
									{{ restroomComputed }}
									Banheiros</span>
                            </li>
                        </ul>

						<a id="sobre"></a>
                        <div class="section" v-if="nameComputed || descriptionComputed">
                            <h2 class="section-title">{{ nameComputed }}</h2>
                            <div class="section-article">
                                <div v-html="descriptionComputed"></div>
                            </div>
                        </div>

						<a id="galeria"></a>
                        <div class="section" v-if="imagesComputed">
                            <h2 class="section-title">Galeria de Imagens</h2>
                            <p class="section-subtitle">Conheça cada detalhe deste imóvel.</p>

                            <base-tabs v-if="responsive">
                                <base-tab
                                    v-for="(gallery, i) in imagesComputed"
                                    :name="gallery.name"
                                    :key="gallery._uid"
                                    :selected="i === 0"
                                >
                                    <div class="gallery">
                                        <div
                                            class="gallery-item embed ratio16by9"
                                            v-for="(photo, index) in gallery.categoriesfiles"
                                            :key="`${gallery.id}-${photo.id}`"
                                        >
                                            <i class="icon fal fa-search-plus"></i>

                                            <img
                                                class="embed-item"
                                                :src="optimizedImageUrl(photo, 'w350')"
                                                :alt="photo.file.name"
                                                @click="$root.$emit('showModal', `_${gallery.id}`).$emit('indexGalleryStart', index)"
                                            />
                                        </div>
                                        <base-modal :id="'_' + gallery.id" :lightbox="true">
											<template v-slot="{ indexModal }" >
												<base-slider class="gallery-slider" :indexModal="indexModal">
													<base-slide
														v-for="photo in gallery.categoriesfiles"
														:key="`${gallery.id}-${photo.id}`"
													>
														<figure>
															<img :src="optimizedImageUrl(photo)" :alt="photo.file.name" />
														</figure>
													</base-slide>
												</base-slider>
											</template>
                                        </base-modal>
                                    </div>
                                </base-tab>
                            </base-tabs>

                            <base-accordion v-else>
                                <accordion-item
                                    v-for="(gallery, i) in imagesComputed"
                                    :name="gallery.name"
                                    :key="'_' + gallery.id"
                                    :selected="i === 0"
                                >
                                    <div class="gallery">
                                        <div
                                            class="gallery-item embed ratio16by9"
                                            v-for="(photo, index) in gallery.categoriesfiles"
                                            :key="`${gallery.id}-${photo.id}`"
                                        >
                                            <i class="icon fal fa-search-plus"></i>
                                            <img
                                                class="embed-item"
                                                :src="optimizedImageUrl(photo, 'w350')"
                                                :alt="photo.file.label"
                                                @click="$root.$emit('showModal', `_${gallery.id}`).$emit('indexGalleryStart', index)"
                                            />
                                        </div>
                                        <base-modal :id="'_' + gallery.id" :lightbox="true">
											<template v-slot="{ indexModal }" >
												<base-slider class="gallery-slider" :indexModal="indexModal">
													<base-slide
														v-for="photo in gallery.categoriesfiles"
														:key="`${gallery.id}-${photo.id}`"
													>
														<figure>
															<img :src="optimizedImageUrl(photo)" :alt="photo.file.name" />
														</figure>
													</base-slide>
												</base-slider>
											</template>
                                        </base-modal>
                                    </div>
                                </accordion-item>
                            </base-accordion>
                        </div>

						<a id="localizacao" />
                        <div class="section" v-if="locationComputed">
                            <h2 class="section-title">Localização</h2>

                            <div class="product-map">
                                <div class="embed ratio16by9">
                                    <img
                                        class="embed-item"
                                        :src="require(`@/Assets/Images/map.png`)"
                                        alt="Google Maps"
                                    />
                                </div>
                                <button class="button -medium -rounded -border-light" @click="openExternalMap">
                                    Abrir no Google Maps
                                </button>
                            </div>
                        </div>

						<a id="plantas"></a>
                        <div class="section" v-if="plantsComputed">
                            <h2 class="section-title">Plantas</h2>
                            <p>Algumas ilustrações detalhadas do imóvel.</p>

                            <base-slider class="blueprint-slider" :arrows="false" :columns="2">
                                <base-slide v-for="(plant, index) in plantsComputed" :key="plant.id">
                                    <div class="blueprint">
                                        <div class="blueprint-header">
                                            <div class="embed ratio16by9">
                                                <img
                                                    class="embed-item"
                                                    :src="optimizedImageUrl(plant,'square_400')"
                                                    :alt="plant.file.name"
                                                />
                                            </div>
                                        </div>
                                        <div
                                            class="blueprint-footer"
                                            @click="$root.$emit('showModal', 'blueprintSlider').$emit('indexGalleryStart', index)"
                                        >
                                            <h6 class="title">{{ plant.file.name }}</h6>
                                            <i class="fal fa-search-plus"></i>
                                        </div>
                                    </div>
                                </base-slide>
                            </base-slider>

                            <base-modal id="blueprintSlider" :lightbox="true">
                                <template v-slot="{ indexModal }">
									<base-slider class="gallery-slider" :indexModal="indexModal">
										<base-slide v-for="plant in plantsComputed" :key="plant.id">
											<figure>
												<img class="embed-item" :src="optimizedImageUrl(plant)" :alt="plant.label" />
												<figcaption>{{ plant.title }}</figcaption>
											</figure>
										</base-slide>
									</base-slider>
								</template>
                            </base-modal>
                        </div>

                        <div class="section" v-if="legalTextField">
                            <h2 class="section-title sr-only">Documentação</h2>
                            <p class="product-documentation">{{ legalTextField }}</p>
                        </div>
                    </div>

                    <div class="product-prices-card">
                        <div class="card">
                            <div class="card-header" v-if="hasUser">
                                <user-picture v-if="userComputed" :user="userComputed" :size="'-medium'" />
                                <user-card v-if="userComputed" :user="userComputed" />
                            </div>
                            <div class="card-contact" v-if="userPhoneComputed">
                                <div class="card-contact-phone">
                                    <i class="fal fa-phone"></i>
                                    <h4>
                                        <div class="title">Ligue Agora:</div>
                                        <strong class="phone">{{ userPhoneComputed }}</strong>
                                    </h4>
                                    <button
                                        class="button -rounded -small -alt"
                                        :class="{ 'sr-only': showPhone }"
                                        @click="showUserPhone()"
                                    >
                                        Ver telefone
                                    </button>
                                </div>
                            </div>

                            <div class="card-body card-body-price bg-color-light" v-if="priceField || condominiumFeeField || iptuPriceField">
								<h3 class="title">Valor do Imóvel</h3>
								<p class="price">{{ toCurrency(priceField) }}</p>
								<p class="desc">{{ textValueForUnityField }}</p>
                            </div>

                            <div class="card-body" v-if="condominiumFeeField || iptuPriceField">
                                <ul class="product-prices">

                                    <li class="product-price" v-if="condominiumFeeField">
                                        <span class="title info-extra">Condomínio</span>
                                        <span class="price">{{ toCurrency(condominiumFeeField) }}</span>
                                    </li>
                                    <li class="product-price" v-if="iptuPriceField">
                                        <span class="title info-extra">IPTU</span>
										<span class="price">{{ toCurrency(iptuPriceField) }}</span>
                                    </li>
                                </ul>
                            </div>
                            <div class="card-footer" v-if="userPhoneComputed">
                                <a class="button -block -contrast -xlarge button-whatsapp-card" @click="openExternalWhatsapp">
									<span class="icon fab fa-whatsapp" aria-hidden="true"></span>
                                    Fale agora comigo no <span class="is-bold">WhatsApp</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- /.product-content -->

				<!-- <property-footer :user="userComputed" /> -->

                <the-footer />
				<ui-user :user="user" />
            </div>
        </transition>
    </div>
</template>

<script>
    import TheFooter from '@/Components/TheFooter'
    import BaseTabs from '@/Components/BaseTabs'
    import BaseTab from '@/Components/BaseTabs/BaseTab'
    import BaseSlider from '@/Components/BaseSlider'
    import BaseSlide from '@/Components/BaseSlider/BaseSlide'
    import BaseBreadcrumbs from '@/Components/BaseBreadcrumbs'
    import UserCard from '@/Components/User/UserCard'
    import UserPicture from '@/Components/User/UserPicture'
    import BaseModal from '@/Components/BaseModal'
    // import ButtonGoBack from '@/Components/ButtonGoBack'
    import ButtonMobileMenu from '@/Components/ButtonMobileMenu'
    import BaseAccordion from '@/Components/BaseAccordion'
    import AccordionItem from '@/Components/BaseAccordion/AccordionItem'
    import BaseSpinner from '@/Components/BaseSpinner'
	import TheNavigation from '@/Components/TheNavigation'
	import uiUser from '@/Components/User'
	// import PropertyFooter from '@/Components/Properties/PropertyFooter';

	import * as Util from '@/Util';

    import defaultImage from '@/Assets/Images/no-image.png'

    import { mapGetters, mapActions } from 'vuex'

    // eslint-disable-next-line
    const stringNormalize = (s) => {
        return s.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    }

    function randomID() {
        let x = () => {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1)
        }
        return x() + x() + '-' + x() + '-' + x() + x() + x()
    }

    export default {
        name: 'Product',

        components: {
            TheFooter,
            BaseTabs,
            BaseTab,
            BaseSlider,
            BaseSlide,
            BaseBreadcrumbs,
            UserCard,
            UserPicture,
            BaseModal,
            // ButtonGoBack,
            ButtonMobileMenu,
            BaseAccordion,
            AccordionItem,
            BaseSpinner,
			TheNavigation,
			uiUser,
			// PropertyFooter
        },

        data() {
            return {
                showPhone: false,
                responsive: window.innerWidth > 768,
            }
        },

        computed: {
            /**
             * Busca a Propriedade e o User no state do VUEX
             */
            ...mapGetters('Product', ['product']),
            ...mapGetters('User', ['user']),

            /**
             * Verifica se o user existe
             */
            hasUser() {
                return !(Object.keys(this.user).length === 0 && this.user.constructor === Object)
            },

            /**
             * Verifica se a propriedade existe
             */
            hasProduct() {
                return !(Object.keys(this.product).length === 0 && this.product.constructor === Object)
            },

            /**
             * Mostra a tela de loading quando os dados de user e product existirem
             */
            showPageContent() {
                return this.hasUser && this.hasProduct
            },

            breadcrumbs() {
                return [
                    {
                        url: 'Product',
                        title: this.nameComputed,
                        param: this.product.id,
                    },
                ]
            },

            idComputed() {
                return randomID()
            },

            fields() {
                if (!(this.product && this.product.field_value.length)) return null
                let fields = {}

                this.product.field_value.forEach(function(item) {
                    if(item.value)
                        fields[item.field.slug.replace(/-/g, '_')] = item.value.trim()
                })
                return fields
            },

            categories() {
                if (!(this.product && this.product.types)) return null
                let items = this.product.types
                let categories = {}

				items.forEach(item => {

					let categoryName = stringNormalize(item.type[0].name)
                            .trim()
                            .replace(/ /g, '_')
                            .toLowerCase()

					if(!categories[categoryName])
						categories[categoryName] = item.item[0].name
					else categories[categoryName] = [
						categories[categoryName],
						item.item[0].name
					]
				})

                // for (const key in data) {
                //     data[key].map(function(item) {
                //         let k = stringNormalize(item.type_name)
                //             .trim()
                //             .replace(/ /g, '_')
                //             .toLowerCase()

                //         if (data[key].length > 1) {
                //             categories[k] = data[key].map(function(el) {
                //                 return el.item_name.trim()
                //             })
                //         } else {
                //             categories[k] = item.item_name
                //         }
                //     })
                // }
                return categories
            },

            /**
             * Computed referentes as principais informações da propriedade
             */
            nameComputed() {
                return this.product && this.product.name ? this.product.name : ''
            },

            descriptionComputed() {
                return this.product && this.product.description ? this.product.description : ''
            },

            titleInfosComputed() {
                return this.product && this.product.infos.title ? this.product.infos.title : ''
            },

            subtitleInfosComputed() {
                return this.product && this.product.infos.subtitle ? this.product.infos.subtitle : ''
            },

            /**
             * Computed referentes as imagens e galerias
             */
            mainImageComputed() {
				const mainImage = this.coverImageUrl(this.product.cover)
				return mainImage ? mainImage : this.defaultImage

            },

            mainSlideComputed() {
                let arr = this.getGallery('images')
                return arr && arr[0] && arr[0].categoriesfiles ? arr[0].categoriesfiles : []
            },

            defaultImage() {
                return defaultImage ? defaultImage : ''
            },

            imagesComputed() {
                return this.getGallery('images')
            },

            plantsComputed() {
                let plants = this.getGallery('plants')
                let arr = []

                if (plants) {
                    for (let i = 0; i < plants.length; i++) {
                        for (let j = 0; j < plants[i].categoriesfiles.length; j++) {
                            arr.push(plants[i].categoriesfiles[j])
                        }
                    }
                }

                return arr ? arr : []
            },

            downloadsComputed() {
                return this.getGallery('downloads')
            },

            /**
             * Computed referentes aos ITEMS
             */
            typeOfBusinessComputed() {
                if (!(this.categories && this.categories.tipo_de_negocio)) return null
                return this.categories.tipo_de_negocio
            },

            segmentComputed() {
                if (!(this.categories && this.categories.segmento)) return null
                return this.categories.segmento
            },

            categoryComputed() {
                if (!(this.categories && this.categories.categoria)) return null
                return this.categories.categoria
            },

            typeComputed() {
                if (!(this.categories && this.categories.tipo)) return null

                return typeof this.categories.tipo == 'string'
					? [ this.categories.tipo ]
					: [...this.categories.tipo]
            },

            statusComputed() {
                if (!(this.categories && this.categories.status)) return null
                return this.categories.status
            },

            bedroomComputed() {
                if (!(this.categories && this.categories.quartos)) return null
                return this.categories.quartos
            },

            suiteComputed() {
                if (!(this.categories && this.categories.suites)) return null
                return this.categories.suites
            },

            garageComputed() {
                if (!(this.categories && this.categories.garagens)) return null
                return this.categories.garagens
            },

            restroomComputed() {
                if (!(this.categories && this.categories.banheiros)) return null
                return this.categories.banheiros
            },

            priceRangeComputed() {
                if (!(this.categories && this.categories.faixa_de_valor)) return null
                return this.categories.faixa_de_valor
            },

            leisureAndSportsComputed() {
                if (!(this.categories && this.categories.lazer_e_esportes)) return null
                return this.categories.lazer_e_esportes
            },

            convenienceAndServicesComputed() {
                if (!(this.categories && this.categories.comodidades_e_servicos)) return null
                return this.categories.comodidades_e_servicos
            },

            safetyComputed() {
                if (!(this.categories && this.categories.seguranca)) return null
                return this.categories.seguranca
            },

            /**
             * Computed referentes aos FIELDS
             */
            spotlightField() {
                if (!(this.fields && this.fields.imovel_destaque)) return null
                return this.fields.imovel_destaque
            },

            incorporationRecordField() {
                if (!(this.fields && this.fields.registro_incorporacao)) return null
                return this.fields.registro_incorporacao
            },

            workField() {
                if (!(this.fields && this.fields.andamento_da_obra)) return null
                return this.fields.andamento_da_obra
            },

            beginningOfTheWorkField() {
                if (!(this.fields && this.fields.inicio_obra && this.fields.inicio_obra.registro_incorporacao)) return null
                return this.fields.inicio_obra
            },

            deliveryForecastField() {
                if (!(this.fields && this.fields.previsao_de_entrega)) return null
                return this.fields.previsao_de_entrega
            },

            legalTextField() {
                if (!(this.fields && this.fields.texto_juridico)) return null
                return this.fields.texto_juridico
            },

            condominiumFeeField() {
                if (!(this.fields && this.fields.valor_condominio)) return null
                return this.fields.valor_condominio
            },

            iptuPriceField() {
                if (!(this.fields && this.fields.valor_iptu)) return null
                return this.fields.valor_iptu
            },

            priceField() {
                if (!(this.fields && this.fields.valor_imovel)) return null
                return this.fields.valor_imovel
            },

            showValuesOnTheSiteField() {
                if (!(this.fields && this.fields.mostrar_valores_no_site)) return null
                return this.fields.mostrar_valores_no_site
            },

            textValueForUnityField() {
                if (!(this.fields && this.fields.texto_refer_valor_unidade)) return null
                return this.fields.texto_refer_valor_unidade
            },

            titleSeoField() {
                if (!(this.fields && this.fields.titulo_seo.registro_incorporacao)) return null
                return this.fields.titulo_seo
            },

            descriptionSeoField() {
                if (!(this.fields && this.fields.descricao_seo.registro_incorporacao)) return null
                return this.fields.descricao_seo
            },

            areaComputed() {
                return this.product.infos.subtitle;
            },

            locationComputed() {
                if (!this.product.googleMaps) return null

                let googleMaps = this.product.googleMaps.split(',')
                if (googleMaps.length >= 2) {
                    let map = {}

                    map.lat = googleMaps.shift()
                    map.lng = googleMaps.pop()
                    return map
                } else {
                    return null
                }
            },

            /**
             * Computeds referentes ao user
             */
            userComputed() {
                let user = {
                    name: this.userNameComputed,
                    email: this.userEmailComputed,
                    image: this.userPhotoComputed,
                    phone: this.userPhoneComputed,
                    creci: this.userCRECIComputed,
                }
                return user
            },

            userNameComputed() {
                let fullName = ''
                let name = this.user.first_name ? this.user.first_name : ''

                fullName = String(name).split(' ')

                if (fullName.length < 2) {
                    fullName = fullName.shift()
                } else {
                    fullName = fullName.shift() + ' ' + fullName.pop()
                }

                return this.user ? fullName : ''
            },

            userEmailComputed() {
                return this.user && this.user.email ? this.user.email : ''
            },

            userPhotoComputed() {
                const BASE_URL = 'https://cdn.appfacilita.com/'

                if (this.user.photo || this.user.cover)
                    return this.user.photo ? BASE_URL + this.user.photo : BASE_URL + this.user.cover
                else return null
            },

            userPhoneComputed() {
                let number = null
                if (this.user.phone || this.user.mobile)
                    number = this.user.mobile ? this.maskPhone(this.user.mobile) : this.maskPhone(this.user.phone)

                if (!number) return ''

                // limita a quantidade de caracteres
                if (this.showPhone) {
                    return number
                } else {
                    return number.substring(0, 10) + '...'
                }
            },

            userCRECIComputed() {
                return this.user && this.user.creci ? this.user.creci : ''
            },
        },

        beforeCreate() {
            this.$nextTick(() => {
                /**
                 * Faz a requisição da Propriedade e do User
                 */
                this.setProduct().catch((a) => {
                    /** Se der erro na requisição redireciona para a página de erros */
                    if (a.data.status === 'error') this.$router.replace({ name: 'NotFound' })
                })

                this.setUser().catch((a) => {
                    /** Se der erro na requisição redireciona para a página de erros */
                    if (a.data.status === 'error') this.$router.replace({ name: 'NotFound' })
                })
            })
        },

        watch: {
            showPageContent(value) {
                if (value) {
                    document.title = this.userNameComputed + ' - ' + this.nameComputed
                }
            },
        },

        mounted() {
            this.$nextTick(() => {
                window.addEventListener('resize', this.handleResize)
            })
        },

        methods: {
            ...mapActions('Product', ['setProduct']),
            ...mapActions('User', ['setUser']),

            /**
             * @param type String
             * Método para iterar o array de Galerias {galleries_relational}
             *  e retorna o apenas o valor do item especificado no parametro {type}
             */
            getGallery(type) {
                return Util.getGalleryMethod(type, this.product);
            },

            /**
             * Formata o valor para dinheiro em REAL
             */
            toCurrency(v) {
                return new Intl.NumberFormat('pt-Br', { style: 'currency', currency: 'BRL' }).format(v)
            },

            /**
             * Formata o array em formato de lista escrita
             */
            listFormat(data) {
                if (!data) return null
                if (typeof data !== 'object') return data

				// É necessário verificar por que essa função estava tendo resultados diferentes
				// com as mesmas entradas. Por isso a necessidade de um try catch.
				try {
					return new Intl.ListFormat('pt', { style: 'long', type: 'conjunction' }).format(data.sort())
				} catch(err){
					return null
				}
            },

            /**
             * Formata o array em formato de lista escrita
             */
            fromToListFormat(data) {
                if (!data) return null
                if (typeof data !== 'object') return data
                data = data.sort()
                if (data.length == 2) return `${data[0]} e ${data[data.length - 1]}`
                if (data.length > 2) return `${data[0]} - ${data[data.length - 1]}`
                else return data[0]
            },

            /**
             * Abre uma nova aba no browser no google maps
             * apontando para as direçoes da propriedade
             */
            openExternalMap() {
                if (this.locationComputed && this.locationComputed.lat && this.locationComputed.lng) {
                    window.open(
                        `https://www.google.com/maps/dir/?api=1&travelmode=driving&layer=traffic&destination=${this.locationComputed.lat},${this.locationComputed.lng}`
                    )
                }
            },

            /**
             * Redireciona para o link do whatsapp
             */
            openExternalWhatsapp() {
                this.showPhone = true

                let number = this.userPhoneComputed.replace(/\D/g, '')
                window.open(`http://wa.me/55${number}`, '_blank')
            },

            /**
             * Máscara de telefone
             */
            maskPhone(value) {
                let str = value.replace(/\D/g, '').replace(/^0/, '')

                if (str.length > 10) return str.replace(/^(\d\d)(\d{5})(\d{4}).*/, '($1) $2-$3')
                else if (str.length > 5) return str.replace(/^(\d\d)(\d{4})(\d{0,4}).*/, '($1) $2-$3')
                else if (str.length > 2) return str.replace(/^(\d\d)(\d{0,5})/, '$1-$2')
                else return str.replace(/^(\d*)/, '($1')
            },

            /**
             * Mostra o número de telefone completo
             * do user ao clicar no botão 'ver telefone'
             */
            showUserPhone() {
                this.showPhone = true
            },

            /**
             * Altera o layout dinamicamente
             */
            handleResize() {
                this.responsive = window.innerWidth > 1024
            },

			/**
			 * Recebe um item de uma as galerias de "imagem" e retorna uma
			 * url de uma versão otimizada, caso exista.
			 */
			optimizedImageUrl(item, format = ''){
				if(!item.file) return ''

				const files = item.file.files_relational
				let file = null
				let url = ''

				if(format)
					file = files.find(
						(image) => image.alias == format
					)

				if(file) url = file.url
				else if(item.file.url) url = item.file.url
				else if(item.file.path) url = 'https://cdn.appfacilita.com/' + item.file.path
				else if(files.length) url = files[0].url

				return url
			},

			coverImageUrl(cover){
				if(!cover) return
				let url = ''
				if(cover.url) url = cover.url
				else if(cover.path) url = 'https://cdn.appfacilita.com/' + cover.path
				return url
			}
        },
    }
</script>

<style lang="stylus" scoped>
    @import 'style.styl'
</style>
